import { useTranslation } from 'react-i18next'
import { Radio } from 'antd'
import { AccessToCoursesEnum } from 'enum/accessToCourses'
import { Wrapper, Option, Title, Subtitle } from './styled'

interface IProps {
  activeOption: AccessToCoursesEnum
  changeOption: (value: AccessToCoursesEnum) => void
}

const Options = ({ activeOption, changeOption }: IProps) => {
  const { t } = useTranslation()
  const prefix = 'configuration.rolesAndPermissions.form.addCourses.options'

  return (
    <Wrapper>
      <div>
        <Option
          activeOption={activeOption === AccessToCoursesEnum.None}
          onClick={() => changeOption(AccessToCoursesEnum.None)}
        >
          <Radio checked={activeOption === AccessToCoursesEnum.None} />
          <Title>{t(`${prefix}.none.title`)}</Title>
          <Subtitle>{t(`${prefix}.none.description`)}</Subtitle>
        </Option>
      </div>
      <div>
        <Option
          activeOption={activeOption === AccessToCoursesEnum.All}
          onClick={() => changeOption(AccessToCoursesEnum.All)}
        >
          <Radio checked={activeOption === AccessToCoursesEnum.All} />
          <Title>{t(`${prefix}.all.title`)}</Title>
          <Subtitle>{t(`${prefix}.all.description`)}</Subtitle>
        </Option>
      </div>
      <div>
        <Option
          activeOption={activeOption === AccessToCoursesEnum.Specific}
          onClick={() => changeOption(AccessToCoursesEnum.Specific)}
        >
          <Radio checked={activeOption === AccessToCoursesEnum.Specific} />
          <Title>{t(`${prefix}.specific.title`)}</Title>
          <Subtitle>{t(`${prefix}.specific.description`)}</Subtitle>
        </Option>
      </div>
    </Wrapper>
  )
}

export default Options
